"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Log = exports.Logger = exports.ENVIRONMENT = exports.LogLevels = void 0;
exports.LogLevels = {
    Error: 4,
    Info: 1,
    Log: 2,
    Silent: 5,
    Trace: 0,
    Warn: 3,
};
exports.ENVIRONMENT = {
    DEV: 'dev',
    PRE: 'pre',
    QA: 'qa',
    STG: 'stg',
};
const consoleColorsDefault = {
    error: 'background-color: #4A0002; color: #fff',
    info: 'background-color: #3E4711; color: #fff',
    log: 'background-color: #07340A; color: #fff',
    trace: 'background-color: #0E3841; color: #fff',
    warn: 'background-color: #473D02; color: #fff',
};
const loggerDefaultOptions = {
    colors: consoleColorsDefault,
    separator: ':',
    separatorIn: '[',
    separatorOut: ']',
    withColors: true,
};
/**
 * Main class of logger to share on this project and share it on client project with "Log"
 * @deprecated
 * This class is deprecated and will be removed in future versions. Use the new logger implementation instead.
 */
class Logger {
    get logLevel() {
        return this.currentLogLevel;
    }
    set logLevel(value) {
        this.currentLogLevel = value;
    }
    get environment() {
        return this.currentEnvironment;
    }
    set environment(value) {
        this.currentEnvironment = value;
    }
    get prefix() {
        return this.currentPrefix;
    }
    /* istanbul ignore next */
    set prefix(value) {
        this.currentPrefix = value || '';
    }
    constructor(logLevel = Logger.DEFAULT_LOG_LEVEL, prefix = Logger.DEFAULT_PREFIX, loggerOptions) {
        this.environmentOrder = [exports.ENVIRONMENT.DEV, exports.ENVIRONMENT.QA, exports.ENVIRONMENT.STG, exports.ENVIRONMENT.PRE];
        this.options = Object.assign({}, Logger.DEFAULT_OPTIONS, loggerOptions);
        this.options.colors = Object.assign({}, this.options.colors, loggerOptions === null || loggerOptions === void 0 ? void 0 : loggerOptions.colors);
        this.currentLogLevel = logLevel;
        this.currentPrefix = prefix;
        this.currentEnvironment = Logger.DEFAULT_ENVIRONMENT;
    }
    getAllowedEnvironments(currentEnv) {
        const currentIndex = this.environmentOrder.indexOf(currentEnv);
        return currentIndex >= 0 ? this.environmentOrder.slice(0, currentIndex + 1) : [];
    }
    isAllowedEnvironment() {
        const currentEnv = window.ENVIRONMENT;
        const allowedEnvs = this.getAllowedEnvironments(this.currentEnvironment);
        return allowedEnvs.includes(currentEnv);
    }
    hasLevelToSendLog(logLevel) {
        return this.isAllowedEnvironment() && this.currentLogLevel <= logLevel;
    }
    event(...eventName) {
        if (this.hasLevelToSendLog(exports.LogLevels.Info) && eventName.length > 0) {
            window.console.info(...this.addPrefixAndColor([`${this.options.separatorIn}Event ${new Date().toISOString()}${this.options.separatorOut}`, ...eventName], this.options.colors.info));
        }
    }
    trace(...messages) {
        if (this.hasLevelToSendLog(exports.LogLevels.Trace) && messages.length > 0) {
            window.console.trace(...this.addPrefixAndColor(messages, this.options.colors.trace));
        }
    }
    info(...messages) {
        if (this.hasLevelToSendLog(exports.LogLevels.Info) && messages.length > 0) {
            window.console.info(...this.addPrefixAndColor(messages, this.options.colors.info));
        }
    }
    group(...messages) {
        if (this.hasLevelToSendLog(exports.LogLevels.Log) && messages.length > 0) {
            window.console.group(...this.addPrefixAndColor(messages, this.options.colors.log));
        }
    }
    groupCollapsed(...messages) {
        if (this.hasLevelToSendLog(exports.LogLevels.Log) && messages.length > 0) {
            window.console.groupCollapsed(...this.addPrefixAndColor(messages, this.options.colors.log));
        }
    }
    groupEnd() {
        if (this.currentLogLevel <= exports.LogLevels.Log) {
            window.console.groupEnd();
        }
    }
    log(...messages) {
        if (this.hasLevelToSendLog(exports.LogLevels.Log) && messages.length > 0) {
            window.console.log(...this.addPrefixAndColor(messages, this.options.colors.log));
        }
    }
    warn(...messages) {
        if (this.hasLevelToSendLog(exports.LogLevels.Warn) && messages.length > 0) {
            window.console.warn(...this.addPrefixAndColor(messages, this.options.colors.warn));
        }
    }
    error(...messages) {
        if (this.hasLevelToSendLog(exports.LogLevels.Error) && messages.length > 0) {
            window.console.error(...this.addPrefixAndColor(messages, this.options.colors.error));
        }
    }
    /**
     * just add a new prefix to logger
     */
    addPrefix(prefix) {
        var _a;
        if (!this.options.otherPrefixes) {
            this.options.otherPrefixes = [];
        }
        (_a = this.options.otherPrefixes) === null || _a === void 0 ? void 0 : _a.push(prefix);
    }
    /**
     * exposed only for test, don't use it!
     *
     * @param messages unknown[]
     * @param color
     */
    addPrefixAndColor(messages, color) {
        // prefix ?
        const prefixes = this.resolvePrefixes();
        if (prefixes) {
            messages.splice(0, 0, prefixes);
            // has colors ?
            if (this.options.withColors && color && color !== '') {
                messages[0] = `%c${messages[0]}`;
                if (messages.length > 1 && messages[1] && typeof messages[1] === 'string') {
                    messages[0] = `${messages[0]} ${messages[1]}`;
                    messages.splice(1, 1, color);
                }
                else {
                    messages.splice(1, 0, color);
                }
            }
        }
        else {
            // without prefix
            // has colors ?
            if (this.options.withColors && color && color !== '') {
                if (messages.length > 0 && messages[0] && typeof messages[0] === 'string') {
                    messages[0] = `%c${messages[0]}`;
                    messages.splice(1, 0, color);
                }
            }
        }
        return messages;
    }
    resolvePrefixes() {
        let r = [];
        let result = '';
        if (this.currentPrefix && this.currentPrefix !== '') {
            r.push(this.currentPrefix);
        }
        if (this.options.otherPrefixes && this.options.otherPrefixes.length > 0) {
            r = [...r, ...this.options.otherPrefixes];
        }
        if (r.length > 0) {
            result = `${this.options.separatorIn}${r.reverse().join(this.options.separator)}${this.options.separatorOut}`;
        }
        return result;
    }
}
exports.Logger = Logger;
Logger.DEFAULT_LOG_LEVEL = exports.LogLevels.Warn;
Logger.DEFAULT_PREFIX = '';
Logger.DEFAULT_ENVIRONMENT = exports.ENVIRONMENT.DEV;
Logger.DEFAULT_OPTIONS = loggerDefaultOptions;
/**
 * @deprecated
 * This logger is deprecated and will be removed in future versions. Use the new logger implementation instead.
 */
exports.Log = new Logger();
//# sourceMappingURL=logger.js.map